"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.goToPage = void 0;
/* istanbul ignore file @preserve -- No need to test change of window.location.href */
const goToPage = page => window.location.href = page;
exports.goToPage = goToPage;
//# sourceMappingURL=goToPage.js.map